<template>
  <div id="IndexSICPE_div">

    <menusuperior titulo="SICPE" subtitulo="Sistema de Criterios Penales"></menusuperior>
    <menuizquierda></menuizquierda>


    <main class="content-area">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/Comunes/MenuIzquierdaDeLosSistemas.vue'

  export default {
    name: 'Plantilla',
    components: {
      menusuperior,
      menuizquierda
    }
  }
</script>
<style>
  input[type=button],
  button {cursor: pointer;}
  input[type=button]:hover,
  button:hover {background-color: #007bff;}
  td a i {
    color:#343a40!important;
  }
   button {
    overflow: hidden
  }

  .prof-pic {
    font-size: 7vw;
    max-width: 400px;
  }
  td i {
    cursor:pointer;
  }
  .thumb {
  object-fit: cover;
  width:10vw;
  height:10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/SICPE/Comun/Plantilla.vue